import React, {
  useEffect,
  useRef,
  useState,
  Fragment,
  useContext,
  useCallback,
} from "react";
import {
  Alert,
  Badge,
  Card,
  CardBody,
  CardTitle,
  Col,
  Row,
  Spinner,
  Table,
} from "reactstrap";
import { formatExpenseDate } from "../../helpers/utils";
import PageHeader from "../common/PageHeader";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";
import withRedirect from "../../helpers/hoc/withRedirect";
import { useLocation, useHistory, useParams } from "react-router";
import {
  fetchOneAliquotByProperty,
  findMyPaysAsProperty,
  fetchDebtsToPayAsPropertyCuentaPendingPeriodTest,
} from "../../helpers/api/finance";
import { useSelector } from "react-redux";
import Loader from "../common/Loader";
import ButtonIcon from "../common/ButtonIcon";
import {
  faExclamationTriangle,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
import Logo from "../navbar/Logo";
import NumberFormat from "react-number-format";
import { roundAmount } from "../../helpers/currencyConversion";
import { formatPlanillaDate, planillaDueDate } from "../../helpers/planillaDates";
// eslint-disable-next-line import/no-unresolved
import { checkUserToken } from "../../helpers/api/auth";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useReactToPrint } from "react-to-print";
import html2canvas from "html2canvas";
// eslint-disable-next-line import/no-named-as-default
import jsPDF from "jspdf";
import { findConfigAsProperty } from "../../helpers/api/condominium";
import { CurrencyContext } from "../../context/Context";
import ItemImageTitleSubProperty from "../common/ItemImageTitleSubProperty";
import { fetchCondominiumBanksAll } from "../../helpers/api/banks";
import classNames from "classnames";
import {
  isIterableArray,
  Message,
  Or,
  PreloadState,
} from "../UI/preloading/PreloadState";

const PropertyToPayDetail = () => {
  const { id: paramDebtId } = useParams();
  const location = useLocation();
  const initialPeriodId = location.state?.period_id || null;
  const initialDebt = location.state?.debt || null;
  const [debt, setDebt] = useState(initialDebt);
  const period_id = initialPeriodId || debt?.period_id || paramDebtId;
  const history = useHistory();

  const { token, role } = useSelector((state) => state.auth.user);
  const { address, selectedCondominium, condominium, phone } = useSelector(
    (state) => state.condominium
  );
  const { currency: curr, baseCurrency } = useContext(CurrencyContext);

  // HO-TASK-302: cada gasto se muestra en bolivares con la tasa de SU fecha,
  // no con la de hoy. El backend ya manda `expense_date` y `exchange_rate` en
  // cada fila desde HO-TASK-255; esta pantalla los ignoraba y multiplicaba
  // todo por la tasa activa, que es lo que veia distinto el propietario
  // respecto del administrador.
  const rateOf = (cuenta) => {
    const rowRate = Number(cuenta?.exchange_rate?.value || 0);

    // Sin tasa propia se cae en la del dia, que es lo que se mostraba antes.
    return rowRate > 0 ? rowRate : Number(curr?.value || 0);
  };

  const isoOf = (cuenta) =>
    cuenta?.exchange_rate?.currency?.iso || curr?.currency?.iso;

  const expenseDateOf = (cuenta) => formatExpenseDate(cuenta?.expense_date);
  const sumConverted = (rows) =>
    (rows || []).reduce(
      (sum, row) =>
        sum +
        (row?.amount_converted !== undefined && row?.amount_converted !== null
          ? Math.abs(Number(row.amount_converted) || 0)
          : Math.abs(Number(row?.amount) || 0) * rateOf(row)),
      0
    );

  const dateAndRateCells = (cuenta) => (
    <>
      <td className="align-middle text-nowrap">{expenseDateOf(cuenta)}</td>
      <td className="align-middle text-nowrap">
        {isoOf(cuenta) && (
          <NumberFormat
            displayType="text"
            prefix={`${isoOf(cuenta)} `}
            allowedDecimalSeparators={true}
            decimalScale={2}
            fixedDecimalScale
            thousandSeparator={true}
            value={rateOf(cuenta)}
          />
        )}
      </td>
    </>
  );

  const totalAmountCell = (cuenta, value, valueBs) => (
    <td className="align-middle text-right" style={{ width: "20%" }}>
      {value === null || value === undefined ? (
        "-"
      ) : (
        <>
          <span className="d-block font-weight-semi-bold">
            <NumberFormat
              className="text-nowrap"
              displayType="text"
              prefix={`${baseCurrency.symbol} `}
              allowedDecimalSeparators={true}
              decimalScale={2}
              fixedDecimalScale
              thousandSeparator={true}
              value={roundAmount(value)}
            />
          </span>
          {curr?.currency?.iso && (
            <span className="d-block text-700 fs--2 text-nowrap">
              <NumberFormat
                className="text-right text-nowrap"
                displayType="text"
                allowedDecimalSeparators={true}
                decimalScale={2}
                fixedDecimalScale
                thousandSeparator={true}
                prefix={curr?.currency?.iso + " "}
                value={valueBs ?? value * rateOf(cuenta)}
              />
            </span>
          )}
        </>
      )}
    </td>
  );
  const hasActiveRate =
    Boolean(curr?.currency?.iso) && Number(debt?.exchange_rate?.value || curr?.value || 0) > 0;
  const activeRateDate = debt?.exchange_rate?.date || curr?.date || curr?.created_at;
  const [aliquots, setAliquots] = useState(null);

  const [user, setUser] = useState(null);

  const reportRef = useRef();
  const [loading, setLoading] = useState(true);
  const [myPays, setMyPays] = useState({
    data: null,
    loading: true,
    error: null,
  });
  const [payAdded, setPayAdded] = useState(false);
  const [dataConfig, setDataConfig] = useState({
    data: null,
    loading: true,
  });

  const [report, setReport] = useState([]);
  const [reportE, setReportE] = useState([]);
  const [reportI, setReportI] = useState([]);
  const [funds, setFunds] = useState([]);
  const [reportIncomes, setReportIncomes] = useState([]);
  const [amount, setAmount] = useState(0);
  const [amountE, setAmountE] = useState(0);
  const [amountI, setAmountI] = useState(0);
  const [amountF, setAmountF] = useState(0);
  const [amountIncomes, setAmountIncomes] = useState(0);

  const [banks, setBanks] = useState([]);
  const [loadingBanks, setLoadingBanks] = useState(true);
  const [errorBanks, setErrorBanks] = useState(null);

  const [paramsBanks, setParamsBanks] = useState({
    condominiumId: selectedCondominium,
    search: null,
  });

  const fetchApiBanks = useCallback(async () => {
    setLoadingBanks(true);
    setErrorBanks(null);

    try {
      const response = await fetchCondominiumBanksAll(paramsBanks);
      setBanks(response.data && response.data.length >= 0 ? response.data : []);
    } catch (error) {
      setErrorBanks(error);
      setBanks([]);
    } finally {
      setLoadingBanks(false);
    }
  }, [paramsBanks]);

  useEffect(() => {
    fetchApiBanks();
  }, [fetchApiBanks, paramsBanks]);


  const fetchDebtFallback = useCallback(async () => {
    if (debt || !paramDebtId || !selectedCondominium || !period_id) return;
    try {
      const response = await fetchDebtsToPayAsPropertyCuentaPendingPeriodTest(1, 10, {
        condominiumId: selectedCondominium,
        period_id,
        property_id: user.propertyId
      });
      if (response && response.data) {
        if (Array.isArray(response.data) && response.data.length > 0) {
          setDebt(response.data[0]);
        } else if (response.data.id) {
          setDebt(response.data);
        }
      }
    } catch (e) {
      console.error(e);
    }
  }, [debt, paramDebtId, period_id, selectedCondominium, user?.propertyId]);

  useEffect(() => {
    fetchDebtFallback();
  }, [fetchDebtFallback]);

  const fetchApireports = useCallback(async () => {
    if (!debt) return;
    try {
      // type.id 5 = "Deuda Inicial" (saldo inicial importado): se muestra junto
      // a los gastos ordinarios, no como extraordinario (ver TypeFinancesSeeder).
      const financeType1Reports = debt?.accounts?.filter(
        (report) =>
          report.finance !== null &&
          (report?.finance?.type?.id === 1 || report?.finance?.type?.id === 5)
      );
      const financeType2Reports = debt?.accounts?.filter(
        (report) =>
          (report.finance !== null && report?.finance?.type?.id === 2) ||
          (!report.income_id &&
            !report.reserve_fund &&
            !report.reserve_fund_payment_id &&
            Number(report.amount) > 0 &&
            report?.finance?.type?.id !== 1 &&
            report?.finance?.type?.id !== 3 &&
            report?.finance?.type?.id !== 5)
      );

      const financeType3Reports = debt?.accounts?.filter(
        (report) => report.finance !== null && report?.finance?.type?.id === 3
      );
      const reserveReports = debt?.accounts?.filter(
        (report) => report.reserve_fund !== null
      );
      const incomeReports = debt?.accounts?.filter(
        (report) =>
          Boolean(report.income_id) ||
          Boolean(report.income) ||
          Number(report.amount) < 0
      );

      setReport(financeType1Reports ?? []);
      setReportE(financeType2Reports ?? []);
      setReportI(financeType3Reports ?? []);
      setFunds(reserveReports ?? []);
      setReportIncomes(incomeReports ?? []);
    } catch (error) {
      setReport([]);
    }
  }, [debt]);

  useEffect(() => {
    fetchApireports();
  }, [fetchApireports, debt]);

  // HO-TASK-247: los subtotales se guardan con todos sus decimales. Antes cada
  // uno se redondeaba a 2 al calcularlo y finalTotal sumaba esos redondeos, así
  // que el total de la planilla podía no coincidir con la suma real de las
  // filas (los montos se guardan con 6 decimales en la base). El redondeo a 2
  // decimales es cosa de la pantalla: lo hace NumberFormat al mostrarlos.
  useEffect(() => {
    // Gasto ordinario
    const monto = report.reduce((a, c) => {
      return a + Number(c?.amount || 0);
    }, 0);
    setAmount(Number(roundAmount(monto) || 0));

    // Gasto extraordinario

    const montoE = reportE.reduce((a, c) => {
      return a + Number(c?.amount || 0);
    }, 0);
    setAmountE(Number(roundAmount(montoE) || 0));

    // Gasto individual

    const montoI = reportI.reduce((a, c) => {
      return a + Number(c?.amount || 0);
    }, 0);
    setAmountI(Number(roundAmount(montoI) || 0));

    // Fondo de reserva

    const montoF = funds.reduce((a, c) => {
      return a + Number(c?.amount || 0);
    }, 0);
    setAmountF(Number(roundAmount(montoF) || 0));

    // Ingresos aplicados
    const montoInc = reportIncomes.reduce((a, c) => {
      return a + Math.abs(Number(c?.amount || 0));
    }, 0);
    setAmountIncomes(Number(roundAmount(montoInc) || 0));
  }, [report, reportE, reportI, funds, reportIncomes]);

  const finalTotal = React.useMemo(() => {
    if (debt?.total !== undefined && debt?.total !== null) {
      return Number(debt.total);
    }
    return Number(
      roundAmount(
        Number(amount) + Number(amountE) + Number(amountI) + Number(amountF) - Number(amountIncomes)
      ) || 0
    );
  }, [debt?.total, amount, amountE, amountI, amountF, amountIncomes]);

  // total_paid solo se actualiza cuando un pago es aprobado (ver
  // BillToPayController::update), así que sumar esos campos ya refleja
  // únicamente lo confirmado, sin necesidad de mirar el estatus de cada pago.
  const totalPaidFromAccounts = React.useMemo(() => {
    return [...report, ...reportE, ...reportI, ...funds].reduce(
      (a, c) => a + Number(c?.total_paid || 0),
      0
    );
  }, [report, reportE, reportI, funds]);

  const totalPaidConvertedFromAccounts = React.useMemo(() => {
    return [...report, ...reportE, ...reportI, ...funds].reduce(
      (a, c) => a + Number(c?.total_paid_converted || 0),
      0
    );
  }, [report, reportE, reportI, funds]);

  const pendingAmount =
    debt?.total_amount !== undefined && debt?.total_amount !== null
      ? Number(debt.total_amount)
      : Math.max(0, finalTotal - totalPaidFromAccounts);
  const paidAmount = Math.max(0, finalTotal - pendingAmount);
  const isFullyPaid = pendingAmount <= 0;
  const balanceBadge = isFullyPaid
    ? { label: "Pagado", className: "badge-soft-success" }
    : { label: "Pendiente", className: "badge-soft-warning" };

  useEffect(() => {
    if (!selectedCondominium) return;
    if (dataConfig.data) return;
    const loadConfig = async () => {
      try {
        const { data } = await findConfigAsProperty(selectedCondominium);
        setDataConfig({
          data,
          loading: false,
        });
      } catch (error) {
        setDataConfig({
          data: null,
          loading: false,
        });
        console.error("Error fetching config:", error.message);
        handleErrorMessage(error);
      }
    };

    const isMounted = true;

    const findOne = async () => {
      try {
        const response = await checkUserToken(token);
        isMounted && setUser(response);

        const fetchData = async () => {
          try {
            const { data } = await fetchOneAliquotByProperty(
              response.propertyId
            );
            setAliquots(data);
          } catch (error) {
            console.log(error);
            /* handleErrorMessage(error); */
          }
        };
        fetchData();
      } catch (error) {
        handleErrorMessage(error);
      }
    };

    findOne();
    loadConfig();
  }, []);

  const handlePrint = useReactToPrint({
    content: () => reportRef.current,
  });

  const handleDownload = async () => {
    const canvas = await html2canvas(reportRef.current, {
      windowWidth: reportRef.current.scrollWidth,
      windowHeight: reportRef.current.scrollHeight,
    });
    const imgData = canvas.toDataURL("image/png");

    // eslint-disable-next-line new-cap
    const pdf = new jsPDF("p", "mm", "a4"); // A4 size page of PDF

    const imgProps = pdf.getImageProperties(imgData);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);

    pdf.save("Cuenta por pagar de un propietario.pdf");
  };

  const fechaEmision = debt?.accounts?.[0]?.created_at;
  const fechaFormateada = formatPlanillaDate(planillaDueDate(debt?.end_at, fechaEmision));
  const fechaFormateadaE = formatPlanillaDate(fechaEmision);
  const planillaNote = debt?.note ?? dataConfig?.data?.note;

  return (
    <Fragment>
      <PageHeader
        title="Cuenta por pagar"
        titleTag="h2"
        className="mb-3"
        col={{ lg: 9 }}
      />

      {
        /* !loading && */ debt /* && user */ ? (
          <>
            <Card className="mb-3">
              <CardBody>
                <Row className="justify-content-end align-items-center">
                  <Col xs="auto">
                    <ButtonIcon
                      onClick={() => history.goBack()}
                      color="falcon-default"
                      size="sm"
                      icon="chevron-left"
                      className="mr-2 mb-2 mb-sm-0"
                    >
                      Volver
                    </ButtonIcon>
                    <ButtonIcon
                      color="falcon-default"
                      size="sm"
                      icon="arrow-down"
                      onClick={handleDownload}
                      disabled={!debt}
                      className="mr-2 mb-2 mb-sm-0"
                    >
                      Descargar (.pdf)
                    </ButtonIcon>
                    <ButtonIcon
                      onClick={handlePrint}
                      color="falcon-default"
                      size="sm"
                      icon="print"
                      disabled={!debt}
                      className="mr-2 mb-2 mb-sm-0"
                    >
                      Imprimir
                    </ButtonIcon>
                  </Col>
                </Row>
              </CardBody>
            </Card>

            {payAdded && (
              <Alert color="warning" className="shadow-sm">
                <Row>
                  <Col
                    xs="auto"
                    className="d-flex justify-content-center align-items-center"
                  >
                    <FontAwesomeIcon icon={faExclamationTriangle} />
                  </Col>
                  <Col>
                    <p className="mb-0">
                      Ya tiene un pago pendiente por aprobación, hasta que el
                      administrador no apruebe el pago o usted lo cancele no
                      podrá realizar otro pago.
                    </p>
                  </Col>
                </Row>
              </Alert>
            )}

            <Card
              className="mb-3"
              innerRef={(e) => {
                reportRef.current = e;
              }}
            >
              <CardBody>
                <ItemImageTitleSubProperty
                  image={dataConfig?.data?.logo}
                  title1={"Planilla de liquidación de gastos"}
                  titleCondominium={`Condominio: ${condominium}`}
                  titleProperty={"Datos del inmueble"}
                  titleInvoice={"Datos adicionales"}
                  condominium={[
                    {
                      label: "Documento de identificación",
                      value: phone || "No disponible",
                    },

                    { label: "Dirección", value: address },
                  ]}
                  property={[
                    {
                      label: "Propietario",
                      value: `${user?.data?.firstname} ${user?.data?.lastname}`,
                    },

                    {
                      label: "Teléfono",
                      value: user?.data?.phone
                        ? user?.data?.phone
                        : "No disponible",
                    },
                    {
                      label: "Inmueble",
                      value: user?.property || "No disponible",
                    },
                    {
                      label: "Alícuota",
                      value: (aliquots?.value / 100).toFixed(4),
                    },
                  ]}
                  invoice={[
                    ...(debt?.control_number
                      ? [{ label: "N° de control", value: debt.control_number }]
                      : []),
                    {
                      label: "Fecha de emisión",
                      value: debt ? fechaFormateadaE : "No disponible",
                    },
                    {
                      label: "Fecha de vencimiento",
                      value: debt?.end_at ? fechaFormateada : "No disponible",
                    },
                    {
                      label: "Período",
                      value: debt.name,
                    },
                    {
                      label: "Tasa de cambio",
                      value: hasActiveRate ? (
                        <>
                          <NumberFormat
                            displayType="text"
                            prefix={`${baseCurrency.symbol} `}
                            allowedDecimalSeparators={true}
                            decimalScale={2}
                            fixedDecimalScale
                            thousandSeparator={true}
                            value={1}
                          />
                          <NumberFormat
                            displayType="text"
                            prefix={` | ${curr.currency.iso} `}
                            allowedDecimalSeparators={true}
                            decimalScale={2}
                            fixedDecimalScale
                            thousandSeparator={true}
                            value={Number(debt?.exchange_rate?.value || curr.value)}
                          />
                          {activeRateDate &&
                            ` (${formatExpenseDate(activeRateDate)})`}
                        </>
                      ) : (
                        "No disponible"
                      ),
                    },
                  ]}
                  loading={dataConfig.loading}
                />

                {debt && (
                  // mb-3 como el resto de los bloques (HO-TASK-247): con
                  // mt-1 mb-2 quedaba pegado a las tarjetas de datos.
                  <div className="border border-200 rounded mb-3">
                    <Row className="g-0 text-center text-sm-left">
                      <Col xs={12} sm={4} className="pl-4 pr-3 py-1">
                        <div className="fs--1 text-600 font-weight-semi-bold mb-0">
                          Monto total
                        </div>
                        <div className="fs-0 font-weight-bold text-900">
                          <NumberFormat
                            displayType="text"
                            prefix={`${baseCurrency.symbol} `}
                            allowedDecimalSeparators={true}
                            decimalScale={2}
                            fixedDecimalScale
                            thousandSeparator={true}
                            value={finalTotal}
                          />
                        </div>
                        {curr?.currency?.iso && (
                          <div className="fs--1 text-600">
                            <NumberFormat
                              displayType="text"
                              prefix={curr.currency.iso + " "}
                              allowedDecimalSeparators={true}
                              decimalScale={2}
                              fixedDecimalScale
                              thousandSeparator={true}
                              value={debt?.total_bs ?? finalTotal * (curr?.value || 0)}
                            />
                          </div>
                        )}
                      </Col>
                      <Col
                        xs={12}
                        sm={4}
                        className="pl-3 pr-4 py-1 border-left border-200"
                      >
                        <div className="fs--1 text-600 font-weight-semi-bold mb-0">
                          Monto acumulado
                        </div>
                        <div className="fs-0 font-weight-bold text-900">
                          <NumberFormat
                            displayType="text"
                            prefix={`${baseCurrency.symbol} `}
                            allowedDecimalSeparators={true}
                            decimalScale={2}
                            fixedDecimalScale
                            thousandSeparator={true}
                            value={paidAmount}
                          />
                        </div>
                        {curr?.currency?.iso && (
                          <div className="fs--1 text-600">
                            <NumberFormat
                              displayType="text"
                              prefix={curr.currency.iso + " "}
                              allowedDecimalSeparators={true}
                              decimalScale={2}
                              fixedDecimalScale
                              thousandSeparator={true}
                                value={debt?.paid_bs ?? totalPaidConvertedFromAccounts}
                            />
                          </div>
                        )}
                      </Col>
                      <Col
                        xs={12}
                        sm={4}
                        className="pl-3 pr-4 py-1 border-left border-200"
                      >
                        <div className="d-flex justify-content-between align-items-center mb-0">
                          <span className="fs--1 text-600 font-weight-semi-bold">
                            Saldo pendiente
                          </span>
                          <Badge className={classNames("rounded-capsule", balanceBadge.className)}>
                            {balanceBadge.label}
                          </Badge>
                        </div>
                        <div
                          className={classNames(
                            "fs-0 font-weight-bold",
                            isFullyPaid ? "text-900" : "text-warning"
                          )}
                        >
                          <NumberFormat
                            displayType="text"
                            prefix={`${baseCurrency.symbol} `}
                            allowedDecimalSeparators={true}
                            decimalScale={2}
                            fixedDecimalScale
                            thousandSeparator={true}
                            value={pendingAmount}
                          />
                        </div>
                        {curr?.currency?.iso && (
                          <div className="fs--1 text-600">
                            <NumberFormat
                              displayType="text"
                              prefix={curr.currency.iso + " "}
                              allowedDecimalSeparators={true}
                              decimalScale={2}
                              fixedDecimalScale
                              thousandSeparator={true}
                              value={debt?.total_amount_bs ?? pendingAmount * (curr?.value || 0)}
                            />
                          </div>
                        )}
                      </Col>
                    </Row>
                  </div>
                )}

                {isIterableArray(banks) && (
                  <CardBody
                    className={classNames("fs--1", {
                      "p-0": isIterableArray(banks),
                    })}
                  >
                    {" "}
                    <Card
                      title="Bancos"
                      style={{ border: "1px solid rgba(0, 0, 0, .1)" }}
                      className="mb-3 shadow-none"
                    >
                      <CardTitle className="bg-light text-dark text-center fs-0 font-weight-bold py-2 m-0">
                        Datos de pago
                      </CardTitle>
                      <PreloadState
                        cond={isIterableArray(banks)}
                        loading={loadingBanks}
                      >
                        <Or value={true}>
                          {/* HO-TASK-247: mismas columnas que el reporte y que
                          el PDF del correo. La cabecera declaraba 4 columnas y
                          BankListItem pintaba 7 celdas (con correo y fecha de
                          registro), así que cada dato caía bajo el encabezado
                          equivocado. */}
                          <Table responsive className=" fs--1">
                            <thead>
                              <tr>
                                <th className="border-0">DNI</th>
                                <th className="border-0">Banco</th>
                                <th className="border-0">Titular</th>
                                <th className="border-0">Moneda</th>
                                <th className="border-0">Número de cuenta</th>
                              </tr>
                            </thead>
                            <tbody>
                              {banks.map((bank, index) => (
                                <tr key={bank?.bank_id || index}>
                                  <td className="align-middle">
                                    <b>{bank?.owner_dni || "-"}</b>
                                  </td>
                                  <td className="align-middle">
                                    {bank?.name || "-"}
                                  </td>
                                  <td className="align-middle">
                                    {bank?.owner_name || "-"}
                                  </td>
                                  <td className="align-middle">
                                    {bank?.currency?.iso
                                      ? `(${bank.currency.iso}) ${bank.currency.name || ""}`.trim()
                                      : "-"}
                                  </td>
                                  <td className="align-middle">
                                    {bank?.account_number || "-"}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </Or>
                      </PreloadState>
                    </Card>
                  </CardBody>
                )}

                {report && report?.length > 0 && (
                  <div className="table-responsive mt-4 fs--1">
                    <Table striped className="border-bottom">
                      <thead>
                        <tr>
                          <th className="border-0 col-3">Gastos ordinarios</th>
                          <th className="border-0">Descripción</th>
                          <th className="border-0" style={{ whiteSpace: "nowrap" }}>
                            Fecha del gasto
                          </th>
                          <th className="border-0" style={{ whiteSpace: "nowrap" }}>
                            Tasa
                          </th>
                          <th className="border-0 text-right">Monto</th>
                          <th className="border-0 text-right">Cuota</th>
                        </tr>
                      </thead>
                      <tbody>
                        {report.map((cuenta, index) => (
                          <tr key={index}>
                            <td
                              className="align-middle col-3"
                              style={{ width: "30%" }}
                            >
                              {" "}
                              <h6 className="mb-0">
                                {cuenta?.name
                                  ? cuenta?.name
                                  : cuenta.finance.name}{" "}
                              </h6>
                            </td>
                            <td
                              className="align-middle"
                              style={{ width: "30%" }}
                            >
                              {cuenta?.description
                                ? cuenta?.description
                                : cuenta.finance.description}
                            </td>
                            <td className="align-middle text-nowrap">
                              {expenseDateOf(cuenta)}
                            </td>
                            <td className="align-middle text-nowrap">
                              {isoOf(cuenta) && (
                                <NumberFormat
                                  displayType="text"
                                  prefix={`${isoOf(cuenta)} `}
                                  allowedDecimalSeparators={true}
                                  decimalScale={2}
                                  fixedDecimalScale
                                  thousandSeparator={true}
                                  value={rateOf(cuenta)}
                                />
                              )}
                            </td>
                            <td
                              className="align-middle text-right"
                              style={{ width: "20%" }}
                            >
                              <span className="d-block font-weight-semi-bold">
                                <NumberFormat
                                  className="text-nowrap"
                                  displayType="text"
                                  prefix={`${baseCurrency.symbol} `}
                                  allowedDecimalSeparators={true}
                                  decimalScale={2}
                                  fixedDecimalScale
                                  thousandSeparator={true}
                                  value={cuenta?.finance?.value}
                                />
                              </span>
                              {curr?.currency?.iso && (
                                <span className="d-block text-700 fs--2 text-nowrap">
                                  <NumberFormat
                                    className="text-right text-nowrap"
                                    displayType="text"
                                    allowedDecimalSeparators={true}
                                    decimalScale={2}
                                    fixedDecimalScale
                                    thousandSeparator={true}
                                    prefix={curr?.currency?.iso + " "}
                                    value={
                                      cuenta?.finance_amount_converted ?? cuenta?.finance?.value * rateOf(cuenta)
                                    }
                                  />
                                </span>
                              )}
                            </td>
                            <td
                              className="align-middle text-right"
                              style={{ width: "20%" }}
                            >
                              <span className="d-block font-weight-semi-bold">
                                <NumberFormat
                                  className="text-nowrap"
                                  displayType="text"
                                  prefix={`${baseCurrency.symbol} `}
                                  allowedDecimalSeparators={true}
                                  decimalScale={2}
                                  fixedDecimalScale
                                  thousandSeparator={true}
                                  value={roundAmount(cuenta.amount)}
                                />
                              </span>
                              {curr?.currency?.iso && (
                                <span className="d-block text-700 fs--2 text-nowrap">
                                  <NumberFormat
                                    className="text-right text-nowrap"
                                    displayType="text"
                                    allowedDecimalSeparators={true}
                                    decimalScale={2}
                                    fixedDecimalScale
                                    thousandSeparator={true}
                                    prefix={curr?.currency?.iso + " "}
                                    value={cuenta.amount_converted ?? cuenta.amount * rateOf(cuenta)}
                                  />
                                </span>
                              )}
                            </td>
                          </tr>
                        ))}
                        <tr>
                          {/* El total si va a la tasa del dia, no a la de cada gasto. */}
                          <th colSpan={5} className="text-900">Total de gastos ordinarios</th>
                          <td className="align-middle text-right font-weight-semi-bold">
                            <span className="d-block">
                              <NumberFormat
                                className="text-nowrap"
                                displayType="text"
                                prefix={`${baseCurrency.symbol} `}
                                allowedDecimalSeparators={true}
                                decimalScale={2}
                                fixedDecimalScale
                                thousandSeparator={true}
                                value={amount}
                              />
                            </span>
                            {curr?.currency?.iso && (
                              <span className="d-block text-700 fs--2 text-nowrap">
                                <NumberFormat
                                  className="text-right text-nowrap"
                                  displayType="text"
                                  allowedDecimalSeparators={true}
                                  decimalScale={2}
                                  fixedDecimalScale
                                  thousandSeparator={true}
                                  prefix={curr?.currency?.iso + " "}
                                  value={sumConverted(report)}
                                />
                              </span>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                )}

                {reportE && reportE?.length > 0 && (
                  <div className="table-responsive mt-4 fs--1">
                    <Table striped className="border-bottom">
                      <thead>
                        <tr>
                          <th className="border-0 col-3">
                            Gastos extraordinarios
                          </th>
                          <th className="border-0">Descripción</th>
                          <th className="border-0" style={{ whiteSpace: "nowrap" }}>
                            Fecha del gasto
                          </th>
                          <th className="border-0" style={{ whiteSpace: "nowrap" }}>
                            Tasa
                          </th>
                          <th className="border-0 text-right">Monto</th>
                          <th className="border-0 text-right">Cuota</th>
                        </tr>
                      </thead>
                      <tbody>
                        {reportE.map((cuenta, index) => (
                          <tr key={index}>
                            <td
                              className="align-middle col-3"
                              style={{ width: "30%" }}
                            >
                              {" "}
                              <h6 className="mb-0">
                                {cuenta?.name
                                  ? cuenta?.name
                                  : cuenta?.finance?.name}{" "}
                              </h6>
                            </td>
                            <td
                              className="align-middle"
                              style={{ width: "30%" }}
                            >
                              {cuenta?.description
                                ? cuenta?.description
                                : cuenta?.finance?.description}
                            </td>
                            <td className="align-middle text-nowrap">
                              {expenseDateOf(cuenta)}
                            </td>
                            <td className="align-middle text-nowrap">
                              {isoOf(cuenta) && (
                                <NumberFormat
                                  displayType="text"
                                  prefix={`${isoOf(cuenta)} `}
                                  allowedDecimalSeparators={true}
                                  decimalScale={2}
                                  fixedDecimalScale
                                  thousandSeparator={true}
                                  value={rateOf(cuenta)}
                                />
                              )}
                            </td>
                            <td
                              className="align-middle text-right"
                              style={{ width: "20%" }}
                            >
                              <span className="d-block font-weight-semi-bold">
                                <NumberFormat
                                  className="text-nowrap"
                                  displayType="text"
                                  prefix={`${baseCurrency.symbol} `}
                                  allowedDecimalSeparators={true}
                                  decimalScale={2}
                                  fixedDecimalScale
                                  thousandSeparator={true}
                                  value={cuenta?.finance?.value}
                                />
                              </span>
                              {curr?.currency?.iso && (
                                <span className="d-block text-700 fs--2 text-nowrap">
                                  <NumberFormat
                                    className="text-right text-nowrap"
                                    displayType="text"
                                    allowedDecimalSeparators={true}
                                    decimalScale={2}
                                    fixedDecimalScale
                                    thousandSeparator={true}
                                    prefix={curr?.currency?.iso + " "}
                                    value={
                                      cuenta?.finance_amount_converted ?? cuenta?.finance?.value * rateOf(cuenta)
                                    }
                                  />
                                </span>
                              )}
                            </td>
                            <td
                              className="align-middle text-right"
                              style={{ width: "20%" }}
                            >
                              <span className="d-block font-weight-semi-bold">
                                <NumberFormat
                                  className="text-nowrap"
                                  displayType="text"
                                  prefix={`${baseCurrency.symbol} `}
                                  allowedDecimalSeparators={true}
                                  decimalScale={2}
                                  fixedDecimalScale
                                  thousandSeparator={true}
                                  value={roundAmount(cuenta?.amount)}
                                />
                              </span>
                              {curr?.currency?.iso && (
                                <span className="d-block text-700 fs--2 text-nowrap">
                                  <NumberFormat
                                    className="text-right text-nowrap"
                                    displayType="text"
                                    allowedDecimalSeparators={true}
                                    decimalScale={2}
                                    fixedDecimalScale
                                    thousandSeparator={true}
                                    prefix={curr?.currency?.iso + " "}
                                    value={cuenta?.amount_converted ?? cuenta?.amount * rateOf(cuenta)}
                                  />
                                </span>
                              )}
                            </td>
                          </tr>
                        ))}
                        <tr>
                          <th colSpan={5} className="text-900">Total de gastos extraordinarios</th>
                          <td className="align-middle text-right font-weight-semi-bold">
                            <span className="d-block">
                              <NumberFormat
                                className="text-nowrap"
                                displayType="text"
                                prefix={`${baseCurrency.symbol} `}
                                allowedDecimalSeparators={true}
                                decimalScale={2}
                                fixedDecimalScale
                                thousandSeparator={true}
                                value={amountE}
                              />
                            </span>
                            {curr?.currency?.iso && (
                              <span className="d-block text-700 fs--2 text-nowrap">
                                <NumberFormat
                                  className="text-right text-nowrap"
                                  displayType="text"
                                  allowedDecimalSeparators={true}
                                  decimalScale={2}
                                  fixedDecimalScale
                                  thousandSeparator={true}
                                  prefix={curr?.currency?.iso + " "}
                                  value={sumConverted(reportE)}
                                />
                              </span>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                )}

                {reportI && reportI?.length > 0 && (
                  <div className="table-responsive mt-4 fs--1">
                    <Table striped className="border-bottom">
                      <thead>
                        <tr>
                          <th className="border-0 col-3">
                            Gastos particulares
                          </th>
                          <th className="border-0">Descripción</th>
                          <th className="border-0" style={{ whiteSpace: "nowrap" }}>
                            Fecha del gasto
                          </th>
                          <th className="border-0" style={{ whiteSpace: "nowrap" }}>
                            Tasa
                          </th>
                          <th className="border-0 text-right">Monto</th>
                          <th className="border-0 text-right">Cuota</th>
                        </tr>
                      </thead>
                      <tbody>
                        <>
                          {reportI.map((cuenta, index) => (
                            <tr key={index}>
                              <td
                                className="align-middle col-3"
                                style={{ width: "30%" }}
                              >
                                {" "}
                                <h6 className="mb-0">
                                  {cuenta?.name
                                    ? cuenta?.name
                                    : cuenta.finance.name}{" "}
                                </h6>
                              </td>
                              {/*  <td
                                className="align-middle"
                                style={{ width: "20%" }}
                              >
                                {" "}
                                {cuenta.provider_name != null
                                  ? cuenta.provider_name
                                  : cuenta?.finance?.provider?.name}
                              </td> */}
                              <td
                                className="align-middle"
                                style={{ width: "30%" }}
                              >
                                {cuenta?.description
                                  ? cuenta?.description
                                  : cuenta.finance.description}
                              </td>

                              <td className="align-middle text-nowrap">
                                {expenseDateOf(cuenta)}
                              </td>
                              <td className="align-middle text-nowrap">
                                {isoOf(cuenta) && (
                                  <NumberFormat
                                    displayType="text"
                                    prefix={`${isoOf(cuenta)} `}
                                    allowedDecimalSeparators={true}
                                    decimalScale={2}
                                    fixedDecimalScale
                                    thousandSeparator={true}
                                    value={rateOf(cuenta)}
                                  />
                                )}
                              </td>
                              {totalAmountCell(
                                cuenta,
                                cuenta?.concept_amount ?? cuenta?.finance?.value,
                                cuenta?.concept_amount_converted
                              )}
                              <td
                                className="align-middle text-right"
                                style={{ width: "20%" }}
                              >
                                <span className="d-block font-weight-semi-bold">
                                  <NumberFormat
                                    className="text-nowrap"
                                    displayType="text"
                                    prefix={`${baseCurrency.symbol} `}
                                    allowedDecimalSeparators={true}
                                    decimalScale={2}
                                    fixedDecimalScale
                                    thousandSeparator={true}
                                    value={roundAmount(cuenta.amount)}
                                  />
                                </span>
                                {curr?.currency?.iso && (
                                  <span className="d-block text-700 fs--2 text-nowrap">
                                    <NumberFormat
                                      className="text-right text-nowrap"
                                      displayType="text"
                                      allowedDecimalSeparators={true}
                                      decimalScale={2}
                                      fixedDecimalScale
                                      thousandSeparator={true}
                                      prefix={curr?.currency?.iso + " "}
                                      value={cuenta.amount_converted ?? cuenta.amount * rateOf(cuenta)}
                                    />
                                  </span>
                                )}
                              </td>
                            </tr>
                          ))}
                          <tr>
                            <th colSpan={5} className="text-900">Total de gastos particulares</th>
                            <td className="align-middle text-right font-weight-semi-bold">
                              <span className="d-block">
                                <NumberFormat
                                  className="text-nowrap"
                                  displayType="text"
                                  prefix={`${baseCurrency.symbol} `}
                                  allowedDecimalSeparators={true}
                                  decimalScale={2}
                                  fixedDecimalScale
                                  thousandSeparator={true}
                                  value={amountI}
                                />
                              </span>
                              {curr?.currency?.iso && (
                                <span className="d-block text-700 fs--2 text-nowrap">
                                  <NumberFormat
                                    className="text-right text-nowrap"
                                    displayType="text"
                                    allowedDecimalSeparators={true}
                                    decimalScale={2}
                                    fixedDecimalScale
                                    thousandSeparator={true}
                                    prefix={curr?.currency?.iso + " "}
                                    value={sumConverted(reportI)}
                                  />
                                </span>
                              )}
                            </td>
                          </tr>
                        </>
                      </tbody>
                    </Table>
                  </div>
                )}

                {funds && funds?.length > 0 && (
                  <div className="table-responsive mt-4 fs--1">
                    <Table striped className="border-bottom">
                      <thead>
                        <tr>
                          <th className="border-0 col-3">Fondos de reserva</th>
                          <th className="border-0">Descripción</th>
                          <th className="border-0" style={{ whiteSpace: "nowrap" }}>
                            Fecha del gasto
                          </th>
                          <th className="border-0" style={{ whiteSpace: "nowrap" }}>
                            Tasa
                          </th>
                          <th className="border-0 text-right">Monto</th>
                          <th className="border-0 text-right">Cuota</th>
                        </tr>
                      </thead>
                      <tbody>
                        {funds.map(
                          (cuenta, index) =>
                            cuenta.reserve_fund != null && (
                              <tr key={index}>
                                <td
                                  className="align-middle col-3"
                                  style={{ width: "30%" }}
                                >
                                  {" "}
                                  {cuenta.reserve_fund.name}
                                </td>
                                <td
                                  className="align-middle"
                                  style={{ width: "30%" }}
                                >
                                  {" "}
                                  {cuenta.reserve_fund.description}
                                </td>
                                {dateAndRateCells(cuenta)}
                                {totalAmountCell(
                                  cuenta,
                                  cuenta?.concept_amount,
                                  cuenta?.concept_amount_converted
                                )}
                                <td
                                  className="align-middle text-right"
                                  style={{ width: "20%" }}
                                >
                                  <span className="d-block font-weight-semi-bold">
                                    <NumberFormat
                                      className="text-nowrap"
                                      displayType="text"
                                      prefix={`${baseCurrency.symbol} `}
                                      allowedDecimalSeparators={true}
                                      decimalScale={2}
                                      fixedDecimalScale
                                      thousandSeparator={true}
                                      value={roundAmount(cuenta.amount)}
                                    />
                                  </span>
                                  {curr?.currency?.iso && (
                                    <span className="d-block text-700 fs--2 text-nowrap">
                                      <NumberFormat
                                        className="text-right text-nowrap"
                                        displayType="text"
                                        allowedDecimalSeparators={true}
                                        decimalScale={2}
                                        fixedDecimalScale
                                        thousandSeparator={true}
                                        prefix={curr?.currency?.iso + " "}
                                        value={
                                          cuenta.amount_converted ??
                                          cuenta.amount * rateOf(cuenta)
                                        }
                                      />
                                    </span>
                                  )}
                                </td>
                              </tr>
                            )
                        )}
                        <tr>
                          <th colSpan={5} className="text-900">Total fondo de reserva</th>

                          <td className="align-middle text-right font-weight-semi-bold">
                            <span className="d-block">
                              <NumberFormat
                                className="text-nowrap"
                                displayType="text"
                                prefix={`${baseCurrency.symbol} `}
                                allowedDecimalSeparators={true}
                                decimalScale={2}
                                fixedDecimalScale
                                thousandSeparator={true}
                                value={amountF}
                              />
                            </span>
                            {curr?.currency?.iso && (
                              <span className="d-block text-700 fs--2 text-nowrap">
                                <NumberFormat
                                  className="text-right text-nowrap"
                                  displayType="text"
                                  allowedDecimalSeparators={true}
                                  decimalScale={2}
                                  fixedDecimalScale
                                  thousandSeparator={true}
                                  prefix={curr?.currency?.iso + " "}
                                  value={sumConverted(funds)}
                                />
                              </span>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                )}

                {reportIncomes && reportIncomes.length > 0 && (
                  <div className="table-responsive mt-4 fs--1">
                    <Table striped className="border-bottom">
                      <thead>
                        <tr>
                          <th className="border-0 col-3">Ingresos aplicados</th>
                          <th className="border-0">Descripción</th>
                          <th className="border-0" style={{ whiteSpace: "nowrap" }}>
                            Fecha del ingreso
                          </th>
                          <th className="border-0" style={{ whiteSpace: "nowrap" }}>
                            Tasa
                          </th>
                          <th className="border-0 text-right">Monto</th>
                          <th className="border-0 text-right">Descuento</th>
                        </tr>
                      </thead>
                      <tbody>
                        {reportIncomes.map((cuenta, index) => (
                          <tr key={index}>
                            <td className="align-middle col-3" style={{ width: "30%" }}>
                              <h6 className="mb-0">
                                {cuenta?.name || cuenta?.income?.name || "Ingreso a planilla"}
                              </h6>
                            </td>
                            <td className="align-middle" style={{ width: "30%" }}>
                              {cuenta?.description || cuenta?.income?.description}
                            </td>
                            {dateAndRateCells(cuenta)}
                            {totalAmountCell(
                              cuenta,
                              cuenta?.concept_amount,
                              cuenta?.concept_amount_converted
                            )}
                            <td className="align-middle text-right" style={{ width: "20%" }}>
                              <span className="d-block font-weight-semi-bold text-success">
                                <NumberFormat
                                  className="text-nowrap"
                                  displayType="text"
                                  prefix={`- ${baseCurrency.symbol} `}
                                  allowedDecimalSeparators={true}
                                  decimalScale={2}
                                  fixedDecimalScale
                                  thousandSeparator={true}
                                  value={roundAmount(Math.abs(cuenta?.amount || 0))}
                                />
                              </span>
                              <span className="d-block text-700 fs--2 text-nowrap text-success">
                                <NumberFormat
                                  className="text-right text-nowrap"
                                  displayType="text"
                                  allowedDecimalSeparators={true}
                                  decimalScale={2}
                                  fixedDecimalScale
                                  thousandSeparator={true}
                                  prefix={"- " + (curr?.currency?.iso ?? "") + " "}
                                  value={Math.abs(cuenta?.amount || 0) * rateOf(cuenta)}
                                />
                              </span>
                            </td>
                          </tr>
                        ))}
                        <tr>
                          <th colSpan={5} className="text-900">Total ingresos descontados</th>
                          <td className="align-middle text-right font-weight-semi-bold text-success">
                            <span className="d-block">
                              <NumberFormat
                                className="text-nowrap"
                                displayType="text"
                                prefix={`- ${baseCurrency.symbol} `}
                                allowedDecimalSeparators={true}
                                decimalScale={2}
                                fixedDecimalScale
                                thousandSeparator={true}
                                value={amountIncomes}
                              />
                            </span>
                            <span className="d-block text-700 fs--2 text-nowrap text-success">
                              <NumberFormat
                                className="text-right text-nowrap"
                                displayType="text"
                                allowedDecimalSeparators={true}
                                decimalScale={2}
                                fixedDecimalScale
                                thousandSeparator={true}
                                prefix={"- " + (curr?.currency?.iso ?? "") + " "}
                                value={sumConverted(reportIncomes)}
                              />
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                )}

                <Row noGutters className="justify-content-end">
                  {hasActiveRate && activeRateDate && (
                    <Col xs={12} md className="order-2 order-md-1 text-600 fs--1 mt-n2 mt-md-0 pt-md-1 pr-md-3">
                      El monto total a pagar en bolívares es calculado en base a la tasa de cambio del día {formatExpenseDate(activeRateDate)}
                    </Col>
                  )}
                  <Col xs="auto" className="order-1 order-md-2">
                    <Table size="sm" borderless className="fs--1 text-right">
                      <tbody>
                        <tr className="border-top">
                          <th className="text-900">Total a pagar:</th>
                          <td className="font-weight-semi-bold">
                            <span className="d-block">
                              <NumberFormat
                                className="text-right text-nowrap"
                                displayType="text"
                                allowedDecimalSeparators={true}
                                thousandSeparator={true}
                                prefix={`${baseCurrency.symbol} `}
                                value={Number(finalTotal || 0).toFixed(2)}
                              />
                            </span>
                            {curr?.currency?.iso && (
                              <span className="d-block text-700 fs--2 text-nowrap">
                                <NumberFormat
                                  className="text-right text-nowrap"
                                  displayType="text"
                                  allowedDecimalSeparators={true}
                                  thousandSeparator={true}
                                  decimalScale={2}
                                  fixedDecimalScale
                                  prefix={(curr?.currency?.iso || "Bs") + " "}
                                  value={
                                    debt?.total_bs ?? finalTotal * (curr?.value || 0)
                                  }
                                />
                              </span>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </Col>
                </Row>
                {dataConfig.loading ? (
                  <Spinner />
                ) : (
                  <div className="text-start text-muted mt-3 pt-1 mb-0">
                    <Logo
                      to={null}
                      styleImage={{
                        width: "100px",
                      }}
                      className={"mb-2"}
                    />
                    <div className="mb-0">
                      {planillaNote !== "" && (
                        <FontAwesomeIcon
                          icon={faInfoCircle}
                          className="mr-2"
                          size="sm"
                        />
                      )}
                      <pre
                        style={{
                          fontFamily: "Open Sans",
                          fontSize: ".83333rem",
                          color: "#5e6e82",
                          whiteSpace: "pre-wrap",
                          wordBreak: "break-word",
                        }}
                      >
                        {planillaNote}
                      </pre>
                    </div>
                  </div>
                )}
              </CardBody>
            </Card>
          </>
        ) : (
          <Card>
            <Loader padding="py-5" />
          </Card>
        )
      }
    </Fragment>
  );
};

export default withRedirect(PropertyToPayDetail);
